import { ThemingUtility } from '@shared/utils';
import { IThemeConfigResponse } from '@shared/types';

export default function useThemeConfig() {
	const applyThemeConfig = (
		themeConfigResult: PromiseSettledResult<IThemeConfigResponse>,
	) => {
		try {
			if (themeConfigResult.status !== 'fulfilled') return;

			const {
				themeConfig: { primaryColor, buttonColorType },
			} = themeConfigResult.value;

			if (primaryColor) {
				ThemingUtility.applyTheme(primaryColor, buttonColorType);
			}
		} catch (error) {
			console.error('Error applying theme config:', error);
		}
	};

	return {
		applyThemeConfig,
	};
}
